// extracted by mini-css-extract-plugin
export default {"container":"Thumbs_container__yC+K4","item":"Thumbs_item__SR2-g","activeItem":"Thumbs_activeItem__ZyTT9"};